import axios from "axios";
import { toastr } from "react-redux-toastr";
import { reset as resetForm, initialize } from "redux-form";
import { showTabs, selectTab } from "../common/tab/tabActions";
import util from '../consts'
const BASE_URL = util.API_URL;

const INITIAL_VALUES = {
    process_geracao_carne: 'N',
    processo_geracao_pdf_carne:'N',
    processo_geracao_pdf_carne_bloco:'N',
}

export function gerarCarnes(values) {
    return dispatch => {

        axios['post'](`${BASE_URL}/gerarcarnesautomaticos`, values)
            .then(resp => {
                toastr.success('Sucesso', resp.data)
                dispatch(init())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

export function gerarPDFSUnidade(values) {
    return dispatch => {
        axios['post'](`${BASE_URL}/gerar_pdf_carnes_unidade`, values)
            .then(resp => {
                toastr.success('Sucesso', resp.data)
                dispatch(init())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

export function gerarPDFSUnidadeBloco(values) {
    return dispatch => {
        axios['post'](`${BASE_URL}/gerar_pdf_carnes_unidade_bloco`, values)
            .then(resp => {
                toastr.success('Sucesso', resp.data)
                dispatch(init())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}


export async function imprimirCarneAvulso(unidade, lista) {

    return dispatch => {
        axios['get'](`${BASE_URL}/printAvulso/carne`, {
            headers: {
                "unidade": unidade,
                "lista": JSON.stringify(lista),
                'Accept': 'application/pdf',
              }, responseType: 'arraybuffer'
        })
            .then(resp => {
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                window.open(url, "_blank");
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })

    }
}


export function verificaStatusProcessGeracaoCarne() {
    const request = axios.post(`${BASE_URL}/status_process_aut`, { item_config: 'PROCESSO_GERA_CARNE' })
    return {
        type: 'CARNE_AUTOMATICO_PROCESS_GERACAO',
        payload: request
    }
}

export function verificaStatusProcessGeracaoPDF() {
    const request = axios.post(`${BASE_URL}/config`, { item_config: 'CARNE_AUTOMATICO_PROCESS_GERACAO_PDF' })
    return {
        type: 'CARNE_AUTOMATICO_PROCESS_GERACAO_PDF',
        payload: request
    }
}

export function verificaStatusProcessGeracaoPDFBloco() {
    const request = axios.post(`${BASE_URL}/config`, { item_config: 'CARNE_AUTOMATICO_PROCESS_GERACAO_PDF_BLOCO' })
    return {
        type: 'CARNE_AUTOMATICO_PROCESS_GERACAO_PDF_BLOCO',
        payload: request
    }
}

export function getUnidadesAtivas() {
    const request = axios.get(`${BASE_URL}/unidades/ativas`)
    return {
        type: 'UNIDADE_ATIVAS_FETCHED',
        payload: request
    }
}

export function init() {
    return [
        showTabs('rotinas', 'pdfs', 'pdfsbloco','pdfsavulso'),
        //showTabs('rotinas'),
        selectTab('rotinas'),
        verificaStatusProcessGeracaoCarne(),
        verificaStatusProcessGeracaoPDF(),
        verificaStatusProcessGeracaoPDFBloco(),
        getUnidadesAtivas()
    ]
}



// WEBPACK FOOTER //
// ./src/rotinaautomatica/rotina_automaticaAction.js